import React from 'react';
import cx from 'clsx';

import type { StatusType } from './ProductImage';

import styles from './ProductDisabledImageOverlay.module.css';

type Props = {
  isOutOfStock?: boolean;
  type?: 'wideList' | 'grid' | 'list';
  status?: StatusType;
  className?: string;
};

const ProductDisabledImageOverlay = ({
  isOutOfStock,
  type = 'wideList',
  status = 'DISPLAYING',
  className,
}: Props) => {
  const classNames = cx(styles.disabledText, styles[type], className);

  if (isOutOfStock) {
    return <div className={classNames}>임시품절</div>;
  }

  if (status === 'READY_FOR_DISPLAY') {
    return <div className={classNames}>상품 준비중</div>;
  }

  if (status === 'DISPLAY_EXPIRED' || status === 'HIDED') {
    return <div className={classNames}>일시 품절</div>;
  }

  if (status !== 'DISPLAYING') {
    return <div className={classNames}>판매중지</div>;
  }

  // if (mounted && orderTimeNotice) {
  //   return <div className={classNames}>{orderTimeNotice}</div>;
  // }

  return null;
};

export default ProductDisabledImageOverlay;
